<template>
    <div class="campaign-folder-view">
        <div v-if="folderProperties.processStatus.state == $folderService.STATE_UNPROCESSED">
            <form v-bind:name="'form-campaign-folder-'+folderProperties.id" v-bind:id="'form-campaign-folder-'+folderProperties.id">
                <div class="form-check">
                    <input v-model="create" type="checkbox" class="form-check-input" v-on:change="clicked" v-bind:id="'form-campaign-folder-'+folderProperties.id+'-create'" true-value="true" false-value="false">
                    <label class="form-check-label" v-bind:for="'form-campaign-folder-'+folderProperties.id+'-create'">
                        {{folderProperties.label}}: <span v-if="folderProperties.path">{{folderProperties.path}}<span v-if="displayCampaignName">/{{displayCampaignName}}</span></span>
                    </label>
                </div>
            </form>
            <component
                v-if="create == 'true'"
                v-bind:is="'FolderSelector'"
                v-bind:rootFolderName="folderProperties.rootFolderName"
                v-bind:autoSelectRoot="true"
                v-bind:initialState="'expanded'"
                v-on:Folder:select="folderSelected"
            ></component>
        </div>
        <div v-else>
            <div>
                <strong>{{folderProperties.label}}</strong>: <span v-if="folderProperties.path">{{folderProperties.path}}<span v-if="displayCampaignName">/{{displayCampaignName}}</span></span>
            </div>
            <component 
                v-bind:is="'ProcessStatusView'"
                v-bind:processStatus="folderProperties.processStatus"
            ></component>
        </div>
    </div>
</template>

<script>
import FolderSelector from "@/components/FolderSelector.vue";
import ProcessStatusView from "@/components/ProcessStatusView.vue";

import folderServiceFactory from "../services/folder-service.js";

export default {
    name: 'CampaignFolder',
    data: function() {
        return {
            displayCampaignName: "",
            create: "false"
        };
    },
    beforeCreate: function() {
        this.$folderService = folderServiceFactory(this);
    },
    components: {
        FolderSelector,
        ProcessStatusView
    },
    props: [
        "folderProperties",
        "campaignName"
    ],
    watch: {
        campaignName: function(v) {
            if (this.folderProperties.processStatus.state == this.$folderService.STATE_UNPROCESSED) {
                this.displayCampaignName = v;
            }
        }
    },
    methods: {
        folderSelected: function(id, path) {
            this.$emit("CampaignFolder:selected", this.folderProperties.id, id, path);
        },
        clicked: function() {
            if (this.create == "false") {
                this.$emit("CampaignFolder:selected", this.folderProperties.id, "", "");
            }
        }
    }
}
</script>

<style lang="scss">
    .campaign-folder-view {
        .folder-selector-container {
            margin-bottom: 1em;
        }
    }
</style>